import IntegrationsPage from 'routes/Integrations'
import { INTEGRATIONS_REVALIDATE_TIME } from 'routes/constants'
import { getAllCategories } from 'routes/Integrations/helpers'
import { CategoryCompactType } from 'routes/Integrations/helpers/types'

export default function WebsiteIntegrations({
  categories,
}: {
  categories: CategoryCompactType[]
}) {
  return <IntegrationsPage categories={categories} />
}

export async function getStaticProps() {
  const categories = await getAllCategories()

  // Pass data to the page via props
  return {
    props: { categories },
    revalidate: INTEGRATIONS_REVALIDATE_TIME, // In seconds
  }
}

// export async function getServerSideProps({
//   query = {},
// }: {
//   query: { page?: string; search?: string; category?: string }
// }) {
//   const { page, search, category } = query
//
//   const categories = await getAllCategories()
//   const { integrations, totalAmount } = await fetchIntegrations({
//     page,
//     search,
//     category,
//   })
//
//   return {
//     props: { integrations, totalAmount, categories },
//   }
// }
